 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + "." + "f1581fe7b64edbfa61a6" + ".version_1.0.20250113.125435.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-042c63a3":1,"chunk-09e3d794":1,"chunk-109bcff3":1,"chunk-2218eb2c":1,"chunk-36bf302e":1,"chunk-633d19a8":1,"chunk-d4222158":1,"chunk-152c1c50":1,"chunk-1aedb3d7":1,"chunk-20e0a515":1,"chunk-d42533fa":1,"chunk-784b92ed":1,"chunk-206396ba":1,"chunk-04edf2a4":1,"chunk-3802ec03":1,"chunk-388c1cc3":1,"chunk-3eb7f08c":1,"chunk-4b22c8ea":1,"chunk-50501828":1,"chunk-cac22142":1,"chunk-571d12b6":1,"chunk-57231ac2":1,"chunk-5af9cf86":1,"chunk-6bcc0182":1,"chunk-137f22dd":1,"chunk-0239b8a6":1,"chunk-42d503f8":1,"chunk-8b72b45c":1,"chunk-66e37346":1,"chunk-0f7a2008":1,"chunk-5f0d31c6":1,"chunk-bf8c7654":1,"chunk-6eb2c8ee":1,"chunk-75a52eb0":1,"chunk-75b8b1e4":1,"chunk-6d68b5aa":1,"chunk-0be1db66":1,"chunk-f377d3de":1,"chunk-7f7774b2":1,"chunk-3e326774":1,"chunk-beee5e6a":1,"chunk-4a6bd009":1,"chunk-6f0285cd":1,"chunk-bc1b2f62":1,"chunk-df4674a8":1,"chunk-fa3b89c8":1,"chunk-77bbe77b":1,"chunk-7cb75278":1,"chunk-8867a33a":1,"chunk-b052385c":1,"chunk-da7b136e":1,"chunk-dd77c812":1,"chunk-ffd21fec":1,"chunk-572793bf":1,"chunk-586ab329":1,"chunk-2246ad16":1,"chunk-ffc7ff52":1,"chunk-8e84ba68":1,"chunk-c6ef5316":1,"chunk-2670ff62":1,"chunk-9b15b494":1,"chunk-74546d18":1,"chunk-e5d5363a":1,"chunk-5c108da8":1,"chunk-e68ad162":1,"chunk-44f74920":1,"chunk-67ee28b3":1,"chunk-69b8db0b":1,"chunk-6b1c5469":1,"chunk-46123256":1,"chunk-77dfcc6a":1,"chunk-df3c496c":1,"chunk-e9e18dc4":1,"chunk-91836a3c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm.balkangraph":"npm.balkangraph","npm.sortablejs":"npm.sortablejs","npm.vuedraggable":"npm.vuedraggable","npm.vue-google-autocomplete":"npm.vue-google-autocomplete","npm.html2canvas":"npm.html2canvas","npm.ua-parser-js":"npm.ua-parser-js"}[chunkId]||chunkId) + "." + {"chunk-042c63a3":"6251af67","chunk-09e3d794":"d309daa9","chunk-109bcff3":"a83112c8","chunk-2218eb2c":"2c54445f","chunk-36bf302e":"1bba7bae","chunk-2d0c82ae":"31d6cfe0","chunk-2d0df046":"31d6cfe0","chunk-633d19a8":"6ec481ec","chunk-d4222158":"7ac9a93d","chunk-152c1c50":"50026bb4","chunk-1aedb3d7":"b2944d30","chunk-20e0a515":"1b13b42f","chunk-2d0c0c44":"31d6cfe0","chunk-2d0d3a08":"31d6cfe0","chunk-2d0e5b71":"31d6cfe0","chunk-2d0b1d74":"31d6cfe0","chunk-d42533fa":"7078ce39","chunk-2d0bb26d":"31d6cfe0","chunk-784b92ed":"3b29f64b","chunk-2d0c5b53":"31d6cfe0","chunk-2d0ced81":"31d6cfe0","chunk-2d0cf8e0":"31d6cfe0","chunk-2d22daec":"31d6cfe0","chunk-2d0d6d5e":"31d6cfe0","chunk-2d0d0a06":"31d6cfe0","chunk-2d0d7266":"31d6cfe0","chunk-206396ba":"72813fec","chunk-2d0f05f1":"31d6cfe0","chunk-2d20e7b9":"31d6cfe0","chunk-2d230323":"31d6cfe0","chunk-2d237122":"31d6cfe0","chunk-04edf2a4":"c33ee162","chunk-3802ec03":"b4c86909","chunk-388c1cc3":"746c775d","chunk-3eb7f08c":"28328280","chunk-4b22c8ea":"ac9f7b14","chunk-50501828":"7dc86bec","chunk-cac22142":"159c4a70","chunk-571d12b6":"c6c200ff","chunk-57231ac2":"403dd2aa","chunk-5af9cf86":"a386cb88","chunk-6bcc0182":"067f8afb","chunk-1ce9063e":"31d6cfe0","chunk-137f22dd":"da888be0","chunk-0239b8a6":"9237cc8c","chunk-42d503f8":"e53b66fd","chunk-8b72b45c":"58212835","chunk-66e37346":"c9f4b8e7","chunk-0f7a2008":"2c72671a","chunk-5f0d31c6":"475f0c7d","chunk-bf8c7654":"781e30ba","chunk-6eb2c8ee":"21ab8d22","chunk-74754210":"31d6cfe0","chunk-75a52eb0":"bb682585","chunk-75b8b1e4":"8f6f1a2a","chunk-6d68b5aa":"c824ba35","chunk-0be1db66":"086468a0","chunk-2be3591b":"31d6cfe0","chunk-2d0aa936":"31d6cfe0","chunk-f377d3de":"77b15260","chunk-2d0c1b4a":"31d6cfe0","chunk-2d0c8a12":"31d6cfe0","chunk-2d20826f":"31d6cfe0","chunk-7f7774b2":"fdea71ab","chunk-361b1afd":"31d6cfe0","chunk-36e39cb5":"31d6cfe0","chunk-3e326774":"a9d34048","chunk-beee5e6a":"620b91a1","chunk-4a6bd009":"a6902e2b","chunk-65be61ab":"31d6cfe0","chunk-6f0285cd":"858cd3f3","chunk-7723b149":"31d6cfe0","chunk-8e08ae52":"31d6cfe0","chunk-bc1b2f62":"164f21e0","chunk-df4674a8":"4ab938ce","chunk-fa3b89c8":"98ce33f2","chunk-77bbe77b":"dc77ba63","chunk-7cb75278":"404b951c","chunk-8867a33a":"f3d0089a","chunk-b052385c":"dd38995f","chunk-da7b136e":"4f332262","chunk-dd77c812":"d912af4d","chunk-ffd21fec":"1cb0af38","npm.balkangraph":"31d6cfe0","chunk-572793bf":"144d3fc1","npm.sortablejs":"31d6cfe0","npm.vuedraggable":"31d6cfe0","chunk-586ab329":"11ae4fbd","chunk-2246ad16":"0a687bb9","npm.vue-google-autocomplete":"31d6cfe0","chunk-ffc7ff52":"50b7ae4f","chunk-8e84ba68":"f6317b26","chunk-c6ef5316":"b382b2f2","chunk-2670ff62":"fe614ba1","chunk-9b15b494":"8ea15363","chunk-74546d18":"6aa80403","chunk-e5d5363a":"7370a5cc","chunk-5c108da8":"9900a980","chunk-e68ad162":"454f8277","chunk-44f74920":"c9b6c8ce","chunk-67ee28b3":"a1656d90","chunk-69b8db0b":"3f515267","chunk-6b1c5469":"28c0e4b0","npm.html2canvas":"31d6cfe0","chunk-46123256":"340a92f0","npm.ua-parser-js":"31d6cfe0","chunk-77dfcc6a":"08854f71","chunk-df3c496c":"9d5f5048","chunk-e9e18dc4":"7f0814b3","chunk-91836a3c":"eccb1d1c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
